import * as React from 'react'

import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import { useAuthStore } from '@/stores/auth-store'

export function DashboardCtaBanner({ className }: { className?: string }): React.ReactElement {
  const user = useAuthStore((s) => s.user)

  const emailBody = user
    ? `Hello,\n\nMy name is ${user.first_name} ${user.last_name} and I would like to inquire about adding a new vending machine to my organisation.\n\nCould you please contact me to discuss the available options?\n\nKind regards,\n${user.first_name} ${user.last_name}\n${user.email}`
    : `Hello,\n\nI would like to inquire about adding a new vending machine to my organisation.\n\nCould you please contact me to discuss the available options?\n\nKind regards`

  return (
    <div className={cn('flex justify-center', className)}>
      <div className="border-primary flex w-full max-w-3xl items-center justify-between rounded-xl border-2 p-10">
        <div className="flex flex-col gap-6">
          <h2 className="text-primary text-4xl font-extrabold tracking-tight">Add a new machine</h2>
          <p className="text-muted-foreground max-w-sm text-sm">
            Looking to expand your machines? Get in touch with us to add another machine to your
            location
          </p>
          <div>
            <Button className="rounded-full bg-black px-6 text-white hover:bg-black/90" asChild>
              <a
                href={`mailto:sales@junea.nl?subject=${encodeURIComponent('New machine inquiry')}&body=${encodeURIComponent(emailBody)}`}
              >
                Get in touch
              </a>
            </Button>
          </div>
        </div>
        <img
          src="/images/machines/snacks-filled.png"
          alt="Vending machine"
          className="hidden h-56 w-auto object-contain md:block"
        />
      </div>
    </div>
  )
}
